module.exports = __webpack_public_path__ + "web_static/img/circled.b429d8fb.gif";